import zod from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { IntegrationFormSchema } from '../schemas';

export const SmtpIntegrationFormSchema = zod
  .object({
    host: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD)
      .max(100),
    port: zod
      .coerce
      .number({ required_error: MANDATORY_FIELD })
      .int()
      .min(1, 'Porta deve estar entre 1 e 65535.')
      .max(65535, 'Porta deve estar entre 1 e 65535.'),
    enableSsl: zod.boolean().default(false),
    username: zod.string().max(100),
    password: zod.string().max(100),
    fromAddress: zod.string().email().max(100),
  })
  .merge(IntegrationFormSchema);

export const SmtpUpdateSchema = zod
  .object({
    host: zod.string().min(1).max(100).optional(),
    port: zod.coerce.number().int().min(1).max(65535).optional(),
    enableSsl: zod.boolean().optional(),
    username: zod.string().max(100).optional(),
    fromAddress: zod.string().email().max(100).optional(),
  })
  .merge(IntegrationFormSchema.partial());

export const SmtpChangePasswordSchema = zod
  .object({
    id: zod.coerce.number({ required_error: MANDATORY_FIELD }),
    newPassword: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD)
      .max(100),
  })
  .merge(IntegrationFormSchema);